import React from 'react';

import { ReactComponent as BoxIllustration } from './box-illustration.svg';
import MembershipBannerButton from './MembershipBannerButton';

import { I18n } from '../components/translate';

import styles from './DashboardMembershipBanner.module.scss';

const DashboardMembershipBanner = () => {
  return (
    <div
      className="_border _border-gray-200 _rounded-lg _p-6
      _d-flex _justify-content-md-between _align-items-md-center
      _flex-column-reverse _flex-md-row"
    >
      <div>
        <h2 className="_text-4 _text-md-5 _text-gray-900 _mb-3 _font-weight">
          <I18n label="membership_banner.dashboard.title" />
        </h2>
        <p className="_text-2 _text-gray-600 _mb-5">
          <I18n html label="membership_banner.dashboard.description" />
        </p>
        <MembershipBannerButton className="_d-inline-flex _align-items-center" />
      </div>
      <div className="_ml-md-5 _mb-6 _mb-md-0">
        <BoxIllustration className={styles.boxIllustration} aria-hidden />
      </div>
    </div>
  );
};

export default DashboardMembershipBanner;
